// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".layout-navbars-breadcrumb-index[data-v-503da8ce]{height:50px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:var(--prev-bg-topBar);border-bottom:1px solid var(--prev-border-color-lighter);padding-left:15px}", ""]);
// Exports
module.exports = exports;
